import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/ReporteEgresos.css';
import { useUser } from '../lib/UserContext';

function ReporteEgresos() {
  const [egresos, setEgresos] = useState([]);
  const [filteredEgresos, setFilteredEgresos] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState(''); // Fecha inicio
  const [endDate, setEndDate] = useState('');     // Fecha fin
  const [totalSum, setTotalSum] = useState(0); // Estado para la sumatoria de valores
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');

  // Obtener el usuario actual y verificar si es administrador
  const { isAdmin } = useUser();
  const canEditValues = isAdmin();

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    axios.get(`${apiUrl}/Donantes/Egresos`)
      .then((response) => {
        setEgresos(response.data);
        setFilteredEgresos(response.data);
        calculateTotalSum(response.data); // Calcular sumatoria inicial
        console.info(response.data);
      })
      .catch((error) => {
        console.error('Error al obtener los egresos:', error);
      });
  }, [apiUrl]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const normalizeDate = (date) => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
  };


  const normalizeDateEnd = (date) => {
    const normalized = new Date(date);
    normalized.setHours(23, 59, 59, 0);
    return normalized;
  };
  
  const filterEgresos = () => {
    const filtered = egresos.filter((egreso) => {
      const matchesSearch = String(egreso.identificacion).includes(search);
      const egresoDate = normalizeDate(egreso.fechaEgreso);

      const matchesDateRange =
        (!startDate || egresoDate >= normalizeDate(startDate)) &&
        (!endDate || egresoDate <= normalizeDateEnd(endDate));

      return matchesSearch && matchesDateRange;
    });
    setFilteredEgresos(filtered);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const sortedEgresos = [...filteredEgresos].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredEgresos(sortedEgresos);
    setSortConfig({ key, direction });
  };
  
  const calculateTotalSum = (data) => {
    const sum = data.reduce((acc, egresos) => acc + egresos.valor, 0);
    setTotalSum(sum); // Actualizar el estado con la sumatoria
  };
  const formatCurrency = (value) => {
    return Number(value).toLocaleString('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };
  const handleGoBack = () => {
    // Redirigir a la página de Ofrendas
    window.location.href = '/opciones';
  };

  const handleEditClick = (egreso) => {
    if (!canEditValues) {
      toast.error('Solo el administrador puede editar valores');
      return;
    }
    setEditingId(egreso.id);
    setEditValue(egreso.valor);
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditValue('');
  };

  const handleSaveEdit = async (egresoId) => {
    if (!canEditValues) {
      toast.error('Solo el administrador puede editar valores');
      return;
    }

    try {
      const newValue = parseFloat(editValue);
      if (isNaN(newValue) || newValue <= 0) {
        toast.error('El valor debe ser un número positivo');
        return;
      }

      // Actualizar en el backend
      await axios.put(`${apiUrl}/Donantes/Egreso/${egresoId}`, {
        id: egresoId,
        valor: newValue
      });

      // Actualizar en el estado local
      const updatedEgresos = egresos.map(egr => 
        egr.id === egresoId ? { ...egr, valor: newValue } : egr
      );
      
      setEgresos(updatedEgresos);
      
      // Actualizar los filtrados también
      const updatedFiltered = filteredEgresos.map(egr =>
        egr.id === egresoId ? { ...egr, valor: newValue } : egr
      );
      
      setFilteredEgresos(updatedFiltered);
      calculateTotalSum(updatedFiltered);
      
      setEditingId(null);
      setEditValue('');
      toast.success('Valor actualizado exitosamente');
    } catch (error) {
      console.error('Error al actualizar el valor:', error);
      toast.error('Error al actualizar el valor');
    }
  };

  return (
    <div className="reporte-container">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="reporte-content">
        <div className="table-wrapper">
          <div className="search-container">
            <h1 className="reporte-egresos-title">Reporte de Egresos</h1>
            <label htmlFor="search">Filtrar por Identificación:</label>
            <input
              type="text"
              id="search"
              value={search}
              onChange={handleSearchChange}
              placeholder="Ingrese identificación"
            />
            <p></p>
            <br />
            <label htmlFor="start-date">Fecha Inicio:</label>
            <input
              type="date"
              id="start-date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <p></p>
            <label htmlFor="end-date">Fecha Fin:</label>
            <input
              type="date"
              id="end-date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <p></p>
            <button onClick={filterEgresos} className="filter-button">
              Filtrar
            </button>
            <p></p>
                       {/* Mostrar sumatoria total */}
           <div className="total-sum">
              <h3>Total: {formatCurrency(totalSum)}</h3>
            </div>
          </div>
          <div className="table-responsive">
            <table className="egresos-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('identificacion')}>Identificación</th>
                  <th onClick={() => handleSort('nombres')}>Nombres</th>
                  <th onClick={() => handleSort('concepto')}>Concepto</th>
                  <th onClick={() => handleSort('fechaEgreso')}>Fecha Egreso</th>
                  <th onClick={() => handleSort('valor')}>Valor</th>
                  <th onClick={() => handleSort('factura')}>Factura</th>
                  <th onClick={() => handleSort('descripcion')}>Descripción</th>
                  <th onClick={() => handleSort('servicioPublico')}>Servicio Publico</th>
                  {canEditValues && <th>Acciones</th>}
                </tr>
              </thead>
              <tbody>
                {filteredEgresos.map((egreso) => (
                  <tr key={egreso.id}>
                    <td data-label="Identificación">{egreso.identificacion}</td>
                    <td data-label="Nombres">{egreso.nombres}</td>
                    <td data-label="Concepto">{egreso.concepto}</td>
                    <td data-label="Fecha Egreso">{new Date(egreso.fechaEgreso).toLocaleDateString()}</td>
                    <td data-label="Valor">
                      {editingId === egreso.id ? (
                        <input
                          type="number"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          style={{
                            width: '100%',
                            padding: '0.5rem',
                            border: '2px solid #667eea',
                            borderRadius: '4px'
                          }}
                        />
                      ) : (
                        formatCurrency(egreso.valor)
                      )}
                    </td>
                    <td data-label="Factura">{egreso.factura}</td>
                    <td data-label="Descripción">{egreso.descripcion}</td>
                    <td data-label="Servicio Publico">{egreso.servicioPublico}</td>
                    {canEditValues && (
                      <td data-label="Acciones">
                        {editingId === egreso.id ? (
                          <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <button
                              onClick={() => handleSaveEdit(egreso.id)}
                              style={{
                                padding: '0.4rem 0.8rem',
                                background: '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                              title="Guardar"
                            >
                              <i className="fas fa-check"></i>
                            </button>
                            <button
                              onClick={handleCancelEdit}
                              style={{
                                padding: '0.4rem 0.8rem',
                                background: '#dc3545',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                              title="Cancelar"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => handleEditClick(egreso)}
                            style={{
                              padding: '0.4rem 0.8rem',
                              background: '#667eea',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer'
                            }}
                            title="Editar valor"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <p> </p>  <button type="button" className="submit-back" onClick={handleGoBack}>
          Regresar al menú
        </button>
<p> </p><p> </p>.<p> </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReporteEgresos;
